import axios from "axios"

export type AccountAddressMode = "billing" | "shipping"

export interface AccountAddressFormData {
  email: string
  firstName: string
  lastName: string
  cpf: string
  phone: string
  zipCode: string
  street: string
  number: string
  complement: string
  district: string
  city: string
  state: string
}

export interface AccountAddressResponse {
  ok: boolean
  code?: string
  message?: string
  address?: AccountAddressFormData
}

export interface UpdateAccountAddressInput {
  mode: AccountAddressMode
  address: AccountAddressFormData
}

export const getAccountAddress = async (
  mode: AccountAddressMode
): Promise<AccountAddressResponse> => {
  const { data } = await axios.get<AccountAddressResponse>(
    "/api/account/addresses",
    {
      params: {
        mode,
      },
    }
  )

  return data
}

export const updateAccountAddress = async (
  input: UpdateAccountAddressInput
): Promise<AccountAddressResponse> => {
  const { data } = await axios.post<AccountAddressResponse>(
    "/api/account/addresses",
    input
  )

  return data
}
